import type {
  YoginiDashaRequest,
  YoginiDashaResponse,
} from "@ishvaram/api-client";

import { apiRequest } from "./_fetch";

export type {
  YoginiDashaRequest,
  YoginiDashaPeriod,
  YoginiDashaPrediction,
  YoginiDashaResponse,
} from "@ishvaram/api-client";

export async function calculateYoginiDasha(
  req: YoginiDashaRequest
): Promise<YoginiDashaResponse> {
  return apiRequest<YoginiDashaResponse>("/yogini-dasha", {
    method: "POST",
    body: JSON.stringify(req),
  });
}
